import { Plan } from '@raysee/schema';
import { FC } from 'react';

interface Props {
  plan: Plan;
}

export const LimitedTypeBatch: FC<Props> = ({ plan }) => (
  <>
    {plan.disabled && (
      <div className="ml-1 w-24 rounded-md border-2 border-red-500 bg-red-500">
        <p className="px-1 text-center text-xs font-bold text-white">販売停止中</p>
      </div>
    )}
    {plan.isUnlisted && (
      <div className="ml-1 w-24 rounded-md border-2 border-blue-400 bg-blue-400">
        <p className="px-1 text-center text-xs font-bold text-white">シークレット</p>
      </div>
    )}
    {plan.isFirstLimited && (
      <div className="ml-1 w-16 rounded-md border-2 border-yellow-400 bg-yellow-400">
        <p className="px-1 text-center text-xs font-bold text-white">初回限定</p>
      </div>
    )}
    {plan.isRepeatLimited && (
      <div className="ml-1 w-24 rounded-md border-2 border-yellow-400 bg-yellow-400">
        <p className="px-1 text-center text-xs font-bold text-white">リピート限定</p>
      </div>
    )}
  </>
);
